import { render, staticRenderFns } from "./DashboardWidgetApplicationNotifications.vue?vue&type=template&id=42cf67c2&scoped=true&lang=pug&"
import script from "./DashboardWidgetApplicationNotifications.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetApplicationNotifications.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidgetApplicationNotifications.vue?vue&type=style&index=0&id=42cf67c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cf67c2",
  null
  
)

/* custom blocks */
import block0 from "./DashboardWidgetApplicationNotifications.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports